module.exports = __webpack_public_path__ + "static/img/logo-no-bg.a26ebdf9.svg";